// @ts-nocheck

import { useEffect, useState } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// @mui material components
// import Switch from "@mui/material/Switch";

// Soft UI Dashboard React components
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";

// Authentication layout components
import CoverLayout from "../components/CoverLayout";

// Images

import { getCaptcha, login } from "../../../features/auth";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../../Hooks";
import SoftAvatar from "../../../components/common/softAvatar";

function SignIn() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ email: "", password: "", });
  const { captchaLoading, captchaData, status } = useAppSelector((state) => state.auth);



  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    dispatch(login(formData))
      .then((resultAction) => {
        if (login.rejected.match(resultAction)) {
          const message =
            typeof resultAction.payload === "string" && resultAction.payload
              ? resultAction.payload
              : "Sign in failed. Please check your email and password and try again.";
          console.error("Error:: SIGNIN Page:: login rejected ::", message);
          toast.error(message);
          return;
        }

        localStorage.setItem("admin_token", resultAction.payload.data.token);
        localStorage.setItem("user", JSON.stringify(resultAction.payload.data));
        toast.success(resultAction.payload.message || "Signed in successfully.");
        navigate("/users");
      })
      .catch((err) => {
        console.error("Error:: SIGNIN Page:: handleSubmit ::", err);
        toast.error("Sign in failed. Please try again.");
      });
  };

  useEffect(() => {
    console.log("called before");
    dispatch(getCaptcha());
    console.log("called after");
  }, [])

  useEffect(() => {
    console.log({ captchaLoading, captchaData, status })
  }, [captchaLoading, captchaData, status])


  return (
    <CoverLayout
      color="primary"
      title="Welcome Back"
      description="Enter your email and password to sign in"
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={1}>
          <SoftBox mb={0.5} ml={0.5}>
            <SoftTypography
              component="label"
              fontSize="14px"
              variant="caption"
              fontWeight="medium"
            >
              Email
            </SoftTypography>
          </SoftBox>

          <SoftInput
            type="email"
            placeholder="Email"
            onChange={handleChange}
            name="email"
          />
        </SoftBox>

        <SoftBox mb={2}>
          <SoftBox mb={0.5} ml={0.5}>
            <SoftTypography
              component="label"
              fontSize="14px"
              variant="caption"
              fontWeight="medium"
            >
              Password
            </SoftTypography>
          </SoftBox>

          <SoftInput
            type="password"
            placeholder="Password"
            name="password"
            onChange={handleChange}
          />
        </SoftBox>

        <SoftBox mb={2}>
          <SoftBox mb={0.5} ml={0.5}>
            <SoftTypography
              component="label"
              fontSize="14px"
              variant="caption"
              fontWeight="bold"
            >
              Captcha
            </SoftTypography>
          </SoftBox>
          <SoftBox mb={0.5} ml={0.5} sx={{textAlign:'center'}}>
            <img src={captchaData?.data} alt="captcha" />
          </SoftBox>
          <SoftInput
            type="text"
            placeholder="Captcha"
            name="captcha"
            onChange={handleChange}
          />
        </SoftBox>


        {/* <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Remember me
          </SoftTypography>
        </SoftBox> */}

        <SoftBox mt={3} mb={1}>

          <SoftButton
            variant="gradient"
            color="final"
            fullWidth
            onClick={handleSubmit}
          >
            sign in
          </SoftButton>
        </SoftBox>

        <SoftBox mt={3} textAlign="center">

          {/* <SoftTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t have an account?{" "}
            <SoftTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="final"
              fontWeight="medium"
              textGradient
            >
              Sign up
            </SoftTypography>
          </SoftTypography> */}
        </SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
